import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "../ui/dialog";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function ParecerModal({ open, onClose, onSuccess, sdpId, token, existing }) {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    parecer: existing?.parecer || "",
    viabilidade: existing?.viabilidade || "viavel",
    estimativa_horas: existing?.estimativa_horas || "",
    cronograma: existing?.cronograma || ""
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API_URL}/api/sdp/${sdpId}/parecer`, formData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success("Parecer registrado!");
      onSuccess();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erro ao registrar parecer");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Parecer Tecnico</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label>Viabilidade *</Label>
            <Select value={formData.viabilidade} onValueChange={(v) => setFormData(prev => ({ ...prev, viabilidade: v }))}>
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="viavel">Viavel</SelectItem>
                <SelectItem value="inviavel">Inviavel</SelectItem>
                <SelectItem value="requer_analise">Requer Analise Adicional</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label>Parecer Tecnico *</Label>
            <Textarea
              value={formData.parecer}
              onChange={(e) => setFormData(prev => ({ ...prev, parecer: e.target.value }))}
              required
              rows={4}
              placeholder="Analise tecnica detalhada..."
            />
          </div>
          <div>
            <Label>Estimativa de Horas</Label>
            <Input
              type="number"
              value={formData.estimativa_horas}
              onChange={(e) => setFormData(prev => ({ ...prev, estimativa_horas: e.target.value }))}
              placeholder="Ex: 40"
            />
          </div>
          <div>
            <Label>Cronograma Proposto</Label>
            <Textarea
              value={formData.cronograma}
              onChange={(e) => setFormData(prev => ({ ...prev, cronograma: e.target.value }))}
              rows={2}
              placeholder="Etapas e prazos..."
            />
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose}>Cancelar</Button>
            <Button type="submit" disabled={loading}>
              {loading ? "Salvando..." : "Salvar Parecer"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
